import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  inject,
  viewChild,
} from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";

import {
  AsyncActionsModule,
  ButtonModule,
  CardComponent,
  CopyClickDirective,
  FormFieldModule,
  ItemModule,
  SelectModule,
  TypographyModule,
} from "@bitwarden/components";
import { SendFormComponent } from "@bitwarden/send-ui";
import { I18nPipe } from "@bitwarden/ui-common";

import { BvSendDetailsComponent } from "./bv-send-details.component";

@Component({
  selector: "app-bv-send-form",
  templateUrl: "./bv-send-form.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    AsyncActionsModule,
    TypographyModule,
    ItemModule,
    FormFieldModule,
    ReactiveFormsModule,
    SelectModule,
    I18nPipe,
    CopyClickDirective,
    ButtonModule,
    CardComponent,
    BvSendDetailsComponent,
  ],
})
export class BvSendFormComponent extends SendFormComponent {
  private readonly changeDetectorRef = inject(ChangeDetectorRef);

  override readonly sendDetailsComponent = viewChild(BvSendDetailsComponent);

  override async init() {
    this.loading = true;
    this.changeDetectorRef.markForCheck();
    await this.sendFormService.initializeSendForm(this.config());
    this.loading = false;
    this.changeDetectorRef.markForCheck();
  }
}
